/**
 * alpinejs directive to get screen size
 * <div x-screen="isMobile = ($width<1024)">
 *     <span x-show="isMobile"> MOBILE </span>
 * </div>
 *
 * <div x-data x-screen="alert('screen resized')"></div>
 */
document.addEventListener('alpine:init', () => {
//   Alpine.directive('screen', (el, obj, {evaluateLater, effect, cleanup}) => {
//     console.log('alpine.screen.js:11', '  ↴', '\n', 'SCREEN');
//     let {value, expression, modifiers} = obj;
//     let evaluate = evaluateLater(expression);
//     let resizeObserver = new ResizeObserver(entries => {
//       entries.forEach(entry => {
//         evaluate((value) => {
//           //console.log('condition', value)
//         })
//         modifiers.includes('once') && observer.disconnect()
//       })
//     })
//     resizeObserver.observe(el);
//     cleanup(() => observer.disconnect())
//   });

  // viewport width magic helper
  Alpine.magic('vw', () => Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0));

  // viewport height magic helper
  Alpine.magic('vh', () => Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0));
});
